<template>
  <div class="car-rights" :style="{ backgroundImage: `url(${rightsObj.bgImg})` }">
    <div class="car-rights-title fade-up" v-html="rightsObj.title"></div>

    <div class="car-rights-list">
      <div
        class="car-rights-item fade-up"
        v-for="(item, index) in rightsObj.rightsList"
        :key="index"
      >
        <div class="car-rights-icon">
          <img :src="item.icon" :alt="item.name">
        </div>

        <div class="car-rights-text">
          <div class="car-rights-name">{{ item.name }}</div>
          <p class="car-rights-desc" v-html="item.desc"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../../utils/animation.js'

export default {
  name: 'CarPurchaseRights',
  props: {
    rightsObj: {
      type: Object,
      required: true
    },
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.car-rights {
  width: 100%;
  aspect-ratio: 1920 / 1290;
  min-width: 1000px;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;

  .car-rights-title {
    font-size: clamp(50px, 3.54vw, 68px);
    font-weight: 300;
    display: flex;
    align-items: center;

    /deep/ span {
      margin: 0 20px;
      font-size: clamp(120px, 7.81vw, 150px);
    }
  }

  .car-rights-list {
    width: 88%;
    max-width: 1600px;
    margin: 3.5vw auto 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.67vw;
  }

  .car-rights-item {
    min-height: 220px;
    padding: 2.2vw 1.8vw;
    display: flex;
    align-items: flex-start;
    background: rgba(255, 255, 255, 0.08);
    box-sizing: border-box;
  }

  .car-rights-icon {
    width: 3.2vw;
    min-width: 3.2vw;
    height: 3.2vw;
    min-height: 3.2vw;
    margin-right: 1.25vw;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .car-rights-text {
    flex: 1;
  }

  .car-rights-name {
    font-size: clamp(24px, 1.56vw, 30px);
    font-weight: @fw1;
    line-height: 1.4;
    margin-bottom: 0.6vw;
    color: #fff;
  }

  .car-rights-desc {
    margin: 0;
    font-size: clamp(14px, 0.94vw, 18px);
    line-height: 1.9;
    font-weight: @fw2;
    color: rgba(255, 255, 255, 0.7);
  }
}
</style>